import React from 'react';
import { useStyletron } from 'baseui';
import { Heading, HeadingLevel } from 'baseui/heading';
import { nanoid } from 'nanoid';
import { Button, ButtonRow } from '@gtintel/platform-atoms';
import { Document } from '../../components/Documents/DocumentsFlatList';
import { AssignmentContext } from '../context';
const AssignmentAttachments = ({
  attachments,
  assignmentId,
  assignmentName,
  canDelete,
  isLeadPartnerAssignment,
  openRelatedDrawer
}) => {
  const [css] = useStyletron();
  const {
    setRelatedAssignment
  } = React.useContext(AssignmentContext);
  return <div className={css({
    marginTop: '14px'
  })} key={assignmentId}>
      <HeadingLevel>
        <div className={css({
        display: 'flex',
        flexFlow: 'row nowrap',
        justifyContent: 'space-between',
        marginBottom: '8px'
      })}>
          <Heading>{assignmentName ?? `Assignment #${assignmentId}`}</Heading>
          {openRelatedDrawer && <ButtonRow>
              <Button kind="secondary" size="mini" onClick={() => {
            setRelatedAssignment(assignmentId);
            openRelatedDrawer(true);
          }}>
                Upload to assignment
              </Button>
            </ButtonRow>}
        </div>
        {attachments.length > 0 && <div className={css({
        border: '2px solid #e2e2e2',
        borderBottomColor: 'transparent',
        borderRadius: '8px',
        display: 'flex',
        flexFlow: 'column nowrap',
        overflow: 'hidden'
      })}>
            {attachments.map(attachment => <Document key={nanoid()} attachment={attachment} canDelete={canDelete} isLeadPartnerAssignment={isLeadPartnerAssignment} />)}
          </div>}
      </HeadingLevel>
    </div>;
};
export default AssignmentAttachments;